/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { smsReportSchema } from "./smsReportSchema.ts";

export const orgSmsReportListQueryDateAfterSchema = z.iso.datetime().optional();

export const orgSmsReportListQueryDateBeforeSchema = z.iso.datetime().optional();

export const orgSmsReportListQueryOrganizationSchema = z.uuid();

export const orgSmsReportListStatus200Schema = z.array(smsReportSchema);

export const orgSmsReportListResponseSchema = orgSmsReportListStatus200Schema;
